export interface IProps {
  onPreviousStep?: () => void;
  paymentDetails: any;
}

export enum BillingFormTabType {
  PERSONAL = "personal",
  BUSINESS = "business",
}
